import Application from './kernel/Application'

export class App extends Application {} 